import React from "react";

const SelectedOption = ({
  title,
  children,
  linkTo,
  className,
  iconImgSrc,
  style,
  childDivClassName,
}) => {
  return (
    <div className={`mb-2 flex ${className} items-start`} style={style}>
      {iconImgSrc ? <img src={iconImgSrc} className="w-[30px] mr-2" /> : null}
      <a href={linkTo}>
        <h4 className="font-black inline-block mr-2 text-[var(--peachy-pink)]">
          {title}:
        </h4>
      </a>
      <div
        className={`mt-[3px] inline-block ${
          childDivClassName ? childDivClassName : ""
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default SelectedOption;
